const firebaseConfig = {
  apiKey: "AIzaSyDvMXHkPET86jCq2N_JQSxTacULX0R5mM0",
  authDomain: "red-onion-restaurant-by-shakib.firebaseapp.com",
  databaseURL: "https://red-onion-restaurant-by-shakib.firebaseio.com",
  projectId: "red-onion-restaurant-by-shakib",
  storageBucket: "red-onion-restaurant-by-shakib.appspot.com",
  messagingSenderId: "164938945691",
  appId: "1:164938945691:web:c7fb6fb4da75655cb8223e",
};

export default firebaseConfig;
